
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 20C65 20 20 65 20 120c0 24 8.5 47.5 24.5 65.5 15.5 18 37 30 60.5 33.5 5 1 10 1 15 1 55 0 100-45 100-100S175 20 120 20zm0 192c-4.5 0-9.5-.5-14-1-21.5-3.5-41.5-14-55.5-31C36 163.5 28 142 28 120c0-51 41-92 92-92s92 41.5 92 92c0 51-41 92-92 92zm15-152c8.5 0 11.5 7 11.5 11.5v3c0 8.5-7 11.5-11.5 11.5h-2v6.5h23c8.5 0 11.5 7 11.5 11.5l6 63.5v.5c0 8.5-7 11.5-11.5 11.5H77c-8.5 0-11.5-7-11.5-11.5v-.5L72 104c0-8.499 6.999-11.5 11.5-11.5h23V86h-2C96 86 93 79 93 74.5v-3c0-8.499 6.999-11.5 11.5-11.5H135zm.5 17.5c2.001-.5 4-1 4-4v-3c-.5-2-1-4-4-4H105c-2 .5-4 1-4 4v3c.5 2 1 4 4 4h6c2 0 4 2 4 4V96c0 2-2 4-4 4H84c-2 .5-4 1-4 4v.5L74 168c0 1.5.5 3.5 3.5 3.5h85c1.501 0 3.5-.501 4.5-3.5l-6.5-63.5v-.5c-.5-2-1-4-4-4h-27c-2.001-.001-4-2-4-4V81.5c0-2 1.999-3.999 4-4h6z","fill-rule":"nonzero"}})])
          )
        }
      }
    